/**
 * VideoUploadSection Component
 *
 * Thin wrapper around EnhancedVideoInput.
 * Mode: Deep Analysis (Mode 3)
 */
import React from 'react';
import { EnhancedVideoInput } from './EnhancedVideoInput';

export const VideoUploadSection = ({ uploadedVideo, setUploadedVideo, setAnalysis }) => {
  return (
    <EnhancedVideoInput
      uploadedVideo={uploadedVideo}
      setUploadedVideo={setUploadedVideo}
      setAnalysis={setAnalysis}
    />
  );
};
